import Sentences from './Sentences';

export default { Sentences };
